import { ACTIONS_AI } from './actions.ai';
import { ACTIONS_ANALYST_PERFORMANCE } from './actions.analyst_performance';
import { ACTIONS_CANDIDATE_MEDIA } from './actions.candidate_media';
import { ACTIONS_CANDIDATE_RECORDS } from './actions.candidate_records';
import { ACTIONS_CONTACTS } from './actions.contacts';
import { ACTIONS_ELECTION } from './actions.election';
import { ACTIONS_ELECTION_PARAMETERS } from './actions.election_parameters';
import { ACTIONS_ELECTION_RESULT } from './actions.election_result';
import { ACTIONS_ELECTION_RESULT_ANALYTICS } from './actions.election_result_analytics';
import { ACTIONS_ELECTION_OBSERVERS } from './actions.election-observers';
import { ACTIONS_ELECTORAL_DIVISION } from './actions.electoral_divisions';
import { ACTIONS_HELP_CENTRE } from './actions.help_centre';
import { ACTIONS_IREV_EXTRACTION } from './actions.irev_extraction';
import { ACTIONS_MANAGE_AGENTS } from './actions.manage_agents';
import { ACTIONS_MESSAGE_TEMPLATES } from './actions.message_templates';
import { ACTIONS_WALLET } from './actions.my_wallet';
import { ACTIONS_ORGANIZATIONS } from './actions.organizations';
import { ACTIONS_OVERVIEW } from './actions.overview';
import { ACTIONS_PARTY_AGENT } from './actions.party_agents';
import { ACTIONS_RESULT_AUDIT } from './actions.result_audit';
import { ACTIONS_RESULT_PIPELINE } from './actions.result_pipeline';
import { ACTIONS_RESULT_TIME_MACHINE } from './actions.result_time_machine';
import { ACTIONS_RESULT_VERIFICATION } from './actions.result_verification';
import { ACTIONS_SUPPORT } from './actions.support';
import { ACTIONS_SYSTEM_MANAGEMENT } from './actions.system_management';
import { ACTIONS_VESR } from './actions.vesr';
import { ACTIONS_VOTER_INTERACTION } from './actions.voter_interaction';
import { ACTIONS_VOTERS } from './actions.voters';

export const ACTIONS = {
	...ACTIONS_OVERVIEW,
	...ACTIONS_ORGANIZATIONS,
	...ACTIONS_ELECTION_PARAMETERS,
	...ACTIONS_SYSTEM_MANAGEMENT,
	...ACTIONS_ELECTION,
	...ACTIONS_AI,
	...ACTIONS_ELECTION_RESULT,
	...ACTIONS_ELECTION_RESULT_ANALYTICS,
	...ACTIONS_RESULT_VERIFICATION,
	...ACTIONS_RESULT_AUDIT,
	...ACTIONS_RESULT_TIME_MACHINE,
	...ACTIONS_IREV_EXTRACTION,
	...ACTIONS_RESULT_PIPELINE,
	...ACTIONS_ANALYST_PERFORMANCE,
	...ACTIONS_PARTY_AGENT,
	...ACTIONS_MANAGE_AGENTS,
	...ACTIONS_CANDIDATE_MEDIA,
	...ACTIONS_ELECTORAL_DIVISION,
	...ACTIONS_VESR,
	...ACTIONS_WALLET,
	...ACTIONS_VOTER_INTERACTION,
	...ACTIONS_CONTACTS,
	...ACTIONS_VOTERS,
	...ACTIONS_CANDIDATE_RECORDS,
	...ACTIONS_MESSAGE_TEMPLATES,
	...ACTIONS_ELECTION_OBSERVERS,
	...ACTIONS_SUPPORT,
	...ACTIONS_HELP_CENTRE,
	RESULT_UPLOAD: 'results_upload',
	LOGOUT: 'logout',
} as const;

export type ACTIONTYPE = (typeof ACTIONS)[keyof typeof ACTIONS];
